<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Reminder</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm step-guide">
                        <div (click)="moveToTheNextStep('details')" class="mtv-primary-color">
                            <span>Details</span>
                        </div>
                        <div (click)="moveToTheNextStep('conditions')"
                             [ngClass]="{'mtv-primary-color' : (step == 'conditions' || step == 'notification')}">
                            <span>Conditions</span>
                        </div>
                        <div (click)="moveToTheNextStep('notification')"
                             [ngClass]="{'mtv-primary-color' : step == 'notification'}">
                            <span>Notification</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar">
                        <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>

                    <div *ngIf="step == 'details'">
                        <!--  ** Title **  -->
                        <div class="row m-b-sm">
                            <div class="col-sm-4">
                                <label style="margin-top: 2px;">Title</label>
                            </div>
                            <div class="dv-value-edit col-sm-8">
                                <input class="form-control" name="title" [(ngModel)]="data.title" required maxlength="255">
                            </div>
                        </div>

                        <!-- ___ Description ___ -->
                        <div class="row">
                            <div class="col-md-4">
                                <label>Description</label>
                            </div>
                            <div class="col-md-8 fourteenPixelText">
                                <textarea class="form-control"
                                          name="description"
                                          [(ngModel)]="data.description"
                                          maxlength="255">
                                </textarea>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn"
                                    type="button"
                                    [disabled]="isContinueButtonDisabled('details')"
                                    (click)="moveToTheNextStep('conditions')">
                                Continue
                            </button>
                        </div>
                    </div>

                    <div *ngIf="step == 'conditions'">
                        <h3 class="m-b-xs">Condition</h3>
                        <p class="m-b-md" style="color: #a1a4a6;">Conditions that must be met for the trigger to run</p>

                        <div class="row m-b-sm">
                            <div class="col-sm-2">
                                <input class="form-control"
                                       name="value"
                                       maxlength="3"
                                       [(ngModel)]="data.conditionDefinition.value">
                            </div>
                            <div class="col-sm-3">
                                <select class="form-control" name="time" [(ngModel)]="data.conditionDefinition.name">
                                    <option value="" hidden></option>
                                    <option *ngFor="let item of timingSelectValues" [value]="item.value">
                                        {{item.displayName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-3">
                                <select class="form-control" [(ngModel)]="data.conditionDefinition.isAfter" name="isAfter">
                                    <!--<option value="false">Before</option>-->
                                    <option [ngValue]="true">After</option>
                                </select>
                            </div>
                            <div class="col-sm-4 display-flex">
                                <select class="form-control" [(ngModel)]="data.conditionField" name="conditionField">
                                    <option value="" hidden></option>
                                    <option *ngFor="let item of conditionFieldsSelectValues" [value]="item.value">
                                        {{item.displayName}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn"
                                    type="button"
                                    [disabled]="isContinueButtonDisabled('conditions')"
                                    (click)="moveToTheNextStep('notification')">
                                Continue
                            </button>
                        </div>
                    </div>

                    <div *ngIf="step == 'notification'" class="general-tab">
                        <div class="row m-b-sm">
                            <div class="col-sm-12">
                                <select class="form-control" name="forStaff" [(ngModel)]="data.forStaff">
                                    <option [ngValue]="true">Staff</option>
                                    <option [ngValue]="false">Resident</option>
                                </select>
                            </div>
                        </div>
                        <div class="row m-b-sm">
                            <div class="col-md-12">
                                <select class="form-control"
                                        name="useInvitationtemplate"
                                        [(ngModel)]="useInvitationTemplate"
                                        (ngModelChange)="useInvitationTemplateChanged($event)">
                                    <option [ngValue]="false"></option>
                                    <option [ngValue]="true">Default Invitation Message</option>
                                </select>
                            </div>
                        </div>
                        <div class="row m-b-sm">
                            <div class="col-md-2">
                                <label style="margin-top: 2px;">Subject</label>
                            </div>
                            <div class="col-md-10 fourteenPixelText">
                                <input class="form-control" name="subject" [(ngModel)]="data.subject" required>
                            </div>
                        </div>
                        <div class="form-group" id="summernote">{{data.template}}</div>
                        <div class="row" *ngIf="data.forStaff">
                            <div class="col-md-2">
                                <label class="m-t-sm">User Roles</label>
                            </div>
                            <div class="col-md-10">
                                <angular2-multiselect name="users"
                                                      [data]="users"
                                                      [(ngModel)]="data.userRoles"
                                                      [settings]="multiselectSettings">
                                </angular2-multiselect>
                                <spinner [spinnerShow]="showUsersSpinner"></spinner>
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn"
                                    type="submit"
                                    [disabled]="isContinueButtonDisabled('notification') || disabledSubmit">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/directory-reminders-modal/directory-reminders-modal.component.html